import React from 'react';
import { motion } from 'framer-motion';
export function UpcomingDestinations() {
  const destinations = [{
    city: 'Burgau',
    country: 'Portugal',
    date: 'April 2026',
    status: 'Buchbar',
    image: 'https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-4.jpg'
  }, {
    city: 'Mallorca',
    country: 'Spanien',
    date: 'Juni 2026',
    status: 'Coming Soon',
    image: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=600&q=80'
  }, {
    city: 'Koh Samui',
    country: 'Thailand',
    date: 'Januar 2027',
    status: 'Coming Soon',
    image: 'https://images.unsplash.com/photo-1504681869696-d977211a5f4c?w=600&q=80'
  }, {
    city: 'Santorini',
    country: 'Griechenland',
    date: 'Mai 2027',
    status: 'Coming Soon',
    image: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=600&q=80'
  }];
  return <section className="py-24 md:py-32 px-6 bg-white overflow-hidden" data-id="element-361">
      <div className="max-w-7xl mx-auto" data-id="element-362">
        <div className="mb-12" data-id="element-363">
          <span className="block text-xs font-body tracking-[0.3em] text-brand-accent uppercase mb-4" data-id="element-364">
            Kommende Ziele
          </span>
          <h2 className="text-4xl md:text-5xl font-heading text-[#1a1a2e]" data-id="element-365">
            Wohin geht die Reise?
          </h2>
        </div>

        {/* Horizontal scrollable container on mobile, grid on desktop */}
        <div className="flex overflow-x-auto pb-8 -mx-6 px-6 md:mx-0 md:px-0 md:grid md:grid-cols-2 lg:grid-cols-4 gap-6 hide-scrollbar snap-x snap-mandatory" data-id="element-366">
          {destinations.map((dest, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="min-w-[280px] md:min-w-0 flex-shrink-0 snap-start group cursor-pointer" data-id="element-367">
              <div className="relative h-[400px] rounded-xl overflow-hidden mb-6 shadow-sm" data-id="element-368">
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/5 transition-colors duration-500 z-10" data-id="element-369" />
                <img src={dest.image} alt={`${dest.city}, ${dest.country}`} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" data-id="element-370" />
                <div className="absolute top-4 right-4 z-20" data-id="element-371">
                  <span className={`px-3 py-1 text-xs font-medium rounded-full backdrop-blur-md border ${dest.status === 'Buchbar' ? 'bg-brand-accent/10 border-brand-accent text-brand-accent bg-white/90' : 'bg-black/30 border-white/30 text-white'}`} data-id="element-372">
                    {dest.status}
                  </span>
                </div>
              </div>

              <div data-id="element-373">
                <h3 className="text-2xl font-heading text-[#1a1a2e] mb-1 group-hover:text-brand-accent transition-colors" data-id="element-374">
                  {dest.city},{' '}
                  <span className="italic text-[#8a8a9a]" data-id="element-375">{dest.country}</span>
                </h3>
                <p className="text-[#4a4a5a] font-light text-sm" data-id="element-376">{dest.date}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}